import { render, staticRenderFns } from "./StaffComponent.vue?vue&type=template&id=1c1b9eff&scoped=true&"
import script from "./StaffComponent.vue?vue&type=script&lang=js&"
export * from "./StaffComponent.vue?vue&type=script&lang=js&"
import style0 from "./StaffComponent.vue?vue&type=style&index=0&id=1c1b9eff&lang=scss&scoped=true&"
import style1 from "./StaffComponent.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./StaffComponent.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1b9eff",
  null
  
)

export default component.exports